import { PlusSquareIcon, Signal01Icon, Users01Icon } from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  DEVICE_GROUP_OPTIONS,
  DEVICE_STATUS_OPTIONS,
  DEVICE_TAB_ITEMS,
  type DeviceGroupFilter,
  type DeviceStatusFilter,
  type DeviceTypeTab,
} from "../../_constants/devices.const";
import styles from "./DevicesToolbar.module.scss";

type DevicesToolbarProps = {
  typeTab: DeviceTypeTab;
  status: DeviceStatusFilter;
  group: DeviceGroupFilter;
  onTypeTabChange: (value: DeviceTypeTab) => void;
  onStatusChange: (value: DeviceStatusFilter) => void;
  onGroupChange: (value: DeviceGroupFilter) => void;
  onCreateDeviceClick: () => void;
};

export const DevicesToolbar = ({
  typeTab,
  status,
  group,
  onTypeTabChange,
  onStatusChange,
  onGroupChange,
  onCreateDeviceClick,
}: DevicesToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={typeTab}
          onChange={(value) => onTypeTabChange(value as DeviceTypeTab)}
          variant="secondary"
          size="medium"
        >
          {DEVICE_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={status}
            startContent={<Signal01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onStatusChange(value as DeviceStatusFilter)}
          >
            {DEVICE_STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={group}
            startContent={<Users01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onGroupChange(value as DeviceGroupFilter)}
          >
            {DEVICE_GROUP_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          type="button"
          onClick={onCreateDeviceClick}
          startContent={<PlusSquareIcon style={{ width: 20, height: 20 }} />}
        >
          Create device
        </Button>
      </div>
    </div>
  );
};
